<template>
  <div class="subject-category-container container">
    <el-card shadow="hover">
      <template #header>
        <div class="card-header">
          <h2>إدارة تصنيفات المواد</h2>
          <el-button type="primary" @click="handleCreate">
            <el-icon><Plus /></el-icon> إضافة تصنيف جديد
          </el-button>
        </div>
      </template>

      <el-alert
        title="ما هي هذه الواجهة؟"
        type="info"
        description="هذه الواجهة تسمح لك بتصنيف المواد الدراسية إلى مجموعات (مثال: مواد علمية، مواد أدبية). هذا يساعد في تنظيم المواد وتسهيل إدارتها في بقية أجزاء النظام."
        :closable="false"
        show-icon
        style="margin-bottom: 20px;"
      />

      <el-table :data="categories" v-loading="loading" border style="width: 100%">
        <el-table-column prop="name" label="اسم التصنيف" />
        <el-table-column label="الإجراءات" width="150" fixed="right">
          <template #default="{ row }">
            <el-button size="small" @click="handleEdit(row)">تعديل</el-button>
            <el-popconfirm
              title="هل أنت متأكد من حذف هذا التصنيف؟"
              confirm-button-text="نعم"
              cancel-button-text="لا"
              @confirm="handleDelete(row.id)"
            >
              <template #reference><el-button size="small" type="danger">حذف</el-button></template>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- Dialog لإنشاء/تعديل التصنيف -->
    <el-dialog v-model="dialogVisible" :title="dialogTitle" width="40%" :close-on-click-modal="false">
      <el-form :model="form" ref="formRef" label-position="top" :rules="rules">
        <el-form-item label="اسم التصنيف" prop="name">
          <el-input v-model="form.name" placeholder="مثال: مواد علمية" />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">إلغاء</el-button>
          <el-button type="primary" @click="submitForm" :loading="formLoading">
            {{ form.id ? 'تحديث' : 'إنشاء' }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import { ElMessage, ElPopconfirm } from 'element-plus';
import { Plus } from '@element-plus/icons-vue';

export default {
  name: 'SubjectCategoryManagement',
  components: { Plus, ElPopconfirm },
  data() {
    return {
      api: null,
      loading: true,
      categories: [],
      dialogVisible: false,
      formLoading: false,
      form: this.getInitialForm(),
      rules: {
        name: [{ required: true, message: 'اسم التصنيف مطلوب', trigger: 'blur' }],
      },
    };
  },
  computed: {
    dialogTitle() {
      return this.form.id ? 'تعديل تصنيف' : 'إضافة تصنيف جديد';
    },
  },
  created() {
    this.api = axios.create({ baseURL: process.env.VUE_APP_API_BASE_URL || 'https://cale.caledonian.ly/api' });
    this.api.interceptors.request.use((config) => {
      const token = localStorage.getItem('access_token');
      if (token) config.headers['Authorization'] = `Bearer ${token}`;
      return config;
    });
    this.fetchCategories();
  },
  methods: {
    getInitialForm() {
      return { id: null, name: '' };
    },
    async fetchCategories() {
      this.loading = true;
      try {
        const response = await this.api.get('/subject-categories');
        this.categories = response.data.data || response.data;
      } catch (error) {
        ElMessage.error('فشل في جلب التصنيفات.');
      } finally {
        this.loading = false;
      }
    },
    handleCreate() {
      this.form = this.getInitialForm();
      this.dialogVisible = true;
    },
    handleEdit(category) {
      this.form = { ...category };
      this.dialogVisible = true;
    },
    async submitForm() {
      if (!this.$refs.formRef) return;
      await this.$refs.formRef.validate(async (valid) => {
        if (!valid) return;
        this.formLoading = true;
        try {
          if (this.form.id) {
            await this.api.put(`/subject-categories/${this.form.id}`, this.form);
            ElMessage.success('تم تحديث التصنيف بنجاح!');
          } else {
            await this.api.post('/subject-categories', this.form);
            ElMessage.success('تم إنشاء التصنيف بنجاح!');
          }
          this.dialogVisible = false;
          this.fetchCategories();
        } catch (error) {
          const errorMsg = error.response?.data?.errors ? Object.values(error.response.data.errors)[0][0] : (error.response?.data?.message || 'فشلت العملية.');
          ElMessage.error(errorMsg);
        } finally {
          this.formLoading = false;
        }
      });
    },
    async handleDelete(id) {
      try {
        await this.api.delete(`/subject-categories/${id}`);
        ElMessage.success('تم حذف التصنيف بنجاح!');
        this.fetchCategories();
      } catch (error) {
        ElMessage.error(error.response?.data?.message || 'فشل في حذف التصنيف.');
      }
    },
  },
};
</script>

<style scoped>
.subject-category-container {
  padding: 20px;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
